module.exports = __webpack_public_path__ + "static/img/meeting_item2.a93c65a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/meeting_item2.png
// module id = tIxG
// module chunks = 2